"use client";

import { c as _c } from "react/compiler-runtime";
import { Collapsible, classNames } from "@opensea/ui-kit";
import { FilterPanelContainer } from "./FilterPanelContainer";
export function FilterPanel(t0) {
  const $ = _c(26);
  let children;
  let className;
  let content;
  let contentClassName;
  let defaultOpen;
  let disabled;
  let onOpenChange;
  let open;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      content,
      contentClassName,
      className,
      onOpenChange,
      disabled,
      defaultOpen,
      open,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = content;
    $[4] = contentClassName;
    $[5] = defaultOpen;
    $[6] = disabled;
    $[7] = onOpenChange;
    $[8] = open;
    $[9] = rest;
  } else {
    children = $[1];
    className = $[2];
    content = $[3];
    contentClassName = $[4];
    defaultOpen = $[5];
    disabled = $[6];
    onOpenChange = $[7];
    open = $[8];
    rest = $[9];
  }
  let t1;
  if ($[10] !== className) {
    t1 = classNames("h-8 w-full", className);
    $[10] = className;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== contentClassName) {
    t2 = classNames("py-3", contentClassName);
    $[12] = contentClassName;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== content || $[15] !== t2) {
    t3 = <div className={t2}>{content}</div>;
    $[14] = content;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== children || $[18] !== defaultOpen || $[19] !== disabled || $[20] !== onOpenChange || $[21] !== open || $[22] !== rest || $[23] !== t1 || $[24] !== t3) {
    t4 = <FilterPanelContainer><Collapsible className={t1} content={t3} defaultOpen={defaultOpen} disabled={disabled} onOpenChange={onOpenChange} open={open} {...rest}>{children}</Collapsible></FilterPanelContainer>;
    $[17] = children;
    $[18] = defaultOpen;
    $[19] = disabled;
    $[20] = onOpenChange;
    $[21] = open;
    $[22] = rest;
    $[23] = t1;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
}